import React, { useEffect } from "react";
// Libraries
import { useDispatch, useSelector } from "react-redux";
import firebase from "firebase/app";
import "firebase/auth";
import { Route, Switch, Redirect } from "react-router-dom";
import { refreshTokenSaga_ } from "../../stores/Login/Action";
// Screens
import Login from "../Login/Login";
import Main from "../Main/Main";
import { isLoggedin } from "../../stores/Login/Selector";
import Leases from "../Leases/Leases";
import Agreements from "../Agreements/Agreements";
import Companies from "../Companies/Companies";
import ActiveVehicles from "../Vehicles/ActiveVehicles";
import InactiveVehicles from "../Vehicles/InactiveVehicles";
import VehicleDocuments from "../VehicleDocuments";
import VehicleIncidences from "../VehicleIncidences";
import VehicleAlerts from "../VehicleAlerts/VehicleAlerts";
import VehicleMaintenanceAlerts from "../VehicleMaintenanceAlerts";
import Administrators from "../Administrators/Administrators";
import Users from "../Users/Users";
import Alerts from "../Alerts/Alerts";
import AlertsMaintenance from "../AlertsMaintenance";
import Requirements from "../Requirements/Requirements";
import Messages from "../Messages/Messages";
import Providers from "../Providers/Providers";
import { ErrorContextProvider } from "../../Contexts/ErrorContext";
import { Config } from "../../Config";

// Initialize Firebase
firebase.initializeApp(Config.FIREBASE_CONFIG);

const App = () => {
  const loggedin = useSelector(isLoggedin);
  const dispatch = useDispatch();
  const onPageRefresh = () => {
    dispatch(refreshTokenSaga_());
  };

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => onPageRefresh());
  }, []);

  if (!loggedin) {
    //If user is not loged in show the login page
    return <Login />;
  }

  return (
    <ErrorContextProvider>
      <Switch>
        <Route exact path="/">
          <Redirect to="/companies" />
        </Route>
        <Route path="/companies">
          <Main>
            <Companies />
          </Main>
        </Route>
        <Route path="/vehicles/:vehicleId/documents">
          <Main>
            <VehicleDocuments />
          </Main>
        </Route>
        <Route path="/vehicles/:vehicleId/incidences">
          <Main>
            <VehicleIncidences />
          </Main>
        </Route>
        <Route path="/vehicles/inactive">
          <Main>
            <InactiveVehicles />
          </Main>
        </Route>
        <Route path="/vehicles/active">
          <Main>
            <ActiveVehicles />
          </Main>
        </Route>
        <Route path="/administrators">
          <Main>
            <Administrators />
          </Main>
        </Route>
        <Route path="/users">
          <Main>
            <Users />
          </Main>
        </Route>
        <Route path="/vehicle/:vehicleId/alerts/maintenance">
          <Main>
            <VehicleMaintenanceAlerts />
          </Main>
        </Route>
        <Route path="/vehicle/:vehicleId/alerts">
          <Main>
            <VehicleAlerts />
          </Main>
        </Route>
        <Route path="/alerts/maintenance">
          <Main>
            <AlertsMaintenance />
          </Main>
        </Route>
        <Route path="/alerts">
          <Main>
            <Alerts />
          </Main>
        </Route>
        <Route path="/requirements">
          <Main>
            <Requirements />
          </Main>
        </Route>
        <Route path="/agreements">
          <Main>
            <Agreements />
          </Main>
        </Route>
        <Route path="/leases/:agreementId">
          <Main>
            <Leases />
          </Main>
        </Route>
        <Route path="/messages/:requirementId">
          <Main>
            <Messages />
          </Main>
        </Route>
        <Route path="/providers">
          <Main>
            <Providers />
          </Main>
        </Route>
      </Switch>
    </ErrorContextProvider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/Containers/App/App.js